import React from "react";
import Typography from "material-ui/Typography";
import Paper from "material-ui/Paper";
import Icon from "material-ui/Icon";
import Grid from "material-ui/Grid";

import Button from "material-ui/Button";
import TextField from "material-ui/TextField";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import { validateFormData } from "../../../common/formtool";
import withRole from "../../hoc/role";
import { ROLES_CLIENT_ADMIN_MANAGER } from "../../../common/constants";
import CustorgLogo from "../../common/custorg/logo";

import Input, { InputLabel } from "material-ui/Input";
import { FormControl, FormHelperText } from "material-ui/Form";
import Select from "material-ui/Select";
import { MenuItem } from "material-ui/Menu";

const RoleBasedTextField = withRole(
  props => {
    return <TextField {...props} />;
  },
  ROLES_CLIENT_ADMIN_MANAGER,
  props => {
    let ownProps = { ...props };
    delete ownProps.helperText;
    return <TextField disabled {...ownProps} />;
  }
);

const RoleBasedButton = withRole(props => {
  return <Button {...props}>{props.children}</Button>;
}, ROLES_CLIENT_ADMIN_MANAGER);

const RoleBasedDropDown = withRole(
  props => {
    return <FormControl {...props}>{props.children}</FormControl>;
  },
  ROLES_CLIENT_ADMIN_MANAGER,
  props => {
    let ownProps = { ...props };
    delete ownProps.helperText;
    return (
      <FormControl disabled {...ownProps}>
        {props.children}
      </FormControl>
    );
  }
);

class Organisation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: {},
      errors: {},
      customer: {
        name: "",
        contactfirstname: "",
        contactlastname: "",
        telephoneno: "",
        contactemail: "",
        address: "",
        city: "",
        state: "",
        country: "",
        zipcode: "",
        logo: "",
        logopath: "",
        chartmeasurement: "",
        chartlinestyle: "",
        enabled: true,
        wiremapdisplaypreference:
          props.customer && props.customer.wiremapdisplaypreference
            ? props.customer.wiremapdisplaypreference
            : "568B",
        jobarchiveperiod: props.customer ? props.customer.jobarchiveperiod : "",
        reportarchiveperiod: props.customer ? props.customer.reportarchiveperiod : "",
      },
      logoModal: null,
      isUpdateSettingBtnDisabled: true,
      stateexists: false,
      statesOfCountry: null,
      allCountries: [],
      filteredCountries: []
    };
    this.onChange = this.onChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onDisplayPrefChange = this.onDisplayPrefChange.bind(this);
  }

  filterCountriesList = (e) => {
    const key = e.key;
    let { allCountries } = this.state;
    let _filteredCountries = (key.length > 0) ? allCountries.filter(c => c.countryname.toLowerCase().startsWith(key.toLowerCase())) : allCountries;
    if (_filteredCountries.length <= 0 ) {
      _filteredCountries = allCountries;
    }
    else {
      allCountries.forEach(element => {
        if (!_filteredCountries.some(c => c.countrycode == element.countrycode)) {
          _filteredCountries.push(element);
        }
      });
    }
    this.setState({ filteredCountries: _filteredCountries });
    // scroll to the top of the list
    setTimeout(() => {
      let menutop = document.getElementById('menutop');
      if (menutop) {
        menutop.scrollIntoView({ behavior: "smooth" });
        menutop.checked = true;
      }
    }, 100);
  }

  onCloseCountries() {
    setTimeout(() => {
      let { allCountries } = this.state;
      this.setState({ filteredCountries: allCountries });
    }, 500);
  }

  onChange(e) {
    let { filteredCountries } = this.state;
    let customer = { ...this.state.customer };
    let countryStates = { ...this.props.countryStates };
    if (e.target.name === "country") {
      if (customer) {
        let country = filteredCountries.filter(c => c.countrycode == e.target.value)[0];
        if (country.stateexists) {
          let statesList = countryStates.states.filter(
            s => s.countrycode == country.countrycode
          );
          this.setState({ statesOfCountry: statesList });
        }
        if (customer.country != e.target.value)
          customer = { ...customer, state: "" };
        this.setState({ stateexists: country.stateexists ? true : false });
      }
    }
    customer[e.target.name] = e.target.value;
    let errors = { ...this.state.errors };
    errors = {
      ...errors,
      [e.target.name]: false
    };
    this.setState({ customer: customer, errors });
    let { isUpdateSettingBtnDisabled } = this.state;
    if (isUpdateSettingBtnDisabled) {
      this.setState({ isUpdateSettingBtnDisabled: false });
    }
  }

  onDisplayPrefChange(e) {
    let customer = { ...this.state.customer };
    customer[e.target.name] = e.target.value;
    let errors = { ...this.state.errors };
    errors = {
      ...errors,
      [e.target.name]: false
    };
    let { isUpdateSettingBtnDisabled } = this.state;
    if (isUpdateSettingBtnDisabled) {
      this.setState({ isUpdateSettingBtnDisabled: false });
    }
    this.setState({ customer: customer, errors });
  }

  handleSubmit() {
    this.setState({
      error: {}
    });
    let customer = { ...this.state.customer };
    let errors = validateFormData(customer, {
      name: {
        required: this.props.translate("formfield_error_general_required")
      },
      contactfirstname: {
        required: this.props.translate("formfield_error_general_required")
      },
      contactlastname: {
        required: this.props.translate("formfield_error_general_required")
      },
      telephoneno: {
        required: this.props.translate("formfield_error_general_required")
      },
      contactemail: {
        required: this.props.translate("formfield_error_general_required"),
        validEmail: this.props.translate("user_email_error")
      },
      country: {
        required: this.props.translate("formfield_error_general_required")
      },
      state: {
        required: this.state.stateexists && !this.state.customer.state &&  this.props.translate("formfield_error_general_required")
      },
      chartmeasurement: {
        required: this.props.translate("formfield_error_general_required")
      },
      chartlinestyle: {
        required: this.props.translate("formfield_error_general_required")
      },
      wiremapdisplaypreference: {
        required: this.props.translate("formfield_error_general_required")
      }
    });

    const missingFieldName = Object.keys(errors)[0];
    if (missingFieldName) {
      const textField = document.getElementsByName(missingFieldName)[0];
      textField && textField.focus();
    }

    if (Object.keys(errors).length) {
      this.setState({ errors: errors });
    } else {
      let self = this;
      let email = customer.contactemail;
      let name = customer.name;
      this.props
        .update(customer)
        .then(resp => {
          self.setState({
            error: {},
            isUpdateSettingBtnDisabled: true
          });
          this.props.checkArchive(customer.id);
        })
        .catch(err => {
          //error_customerexists comes for Customer
          if (err.errors === "error_customerexists") {
            self.setState({
              error: {
                type: "error_duplicatecustomer",
                data: name
              }
            });
          }
          if (err.errors === "error_organisationexists") {
            self.setState({
              error: {
                type: "error_duplicateorganisation",
                data: name
              }
            });
          }
          //error_duplicateuser comes for Organisation
          if (err.errors === "error_duplicateuser") {
            self.setState({
              error: {
                type: "error_duplicateuser",
                data: email
              }
            });
          }
        });
        if (!this.state.isUpdateSettingBtnDisabled) {
          window.scrollTo(0,0);
        }
    }
  }

  showLogoModal = () => {
    this.setState({
      logoModal: true
    });
  };

  closeLogoModal = () => {
    this.setState({
      logoModal: false
    });
  };

  getUpdateError(error) {
    const { translate, classes } = this.props;
    if (error.type === "error_duplicatecustomer") {
      return (
        <div className={classes.error}>
          <Typography type="subheading" color="inherit">
            {translate("error_duplicatecustomer_title")}
          </Typography>
          <Typography type="body1" color="inherit">
            {translate("error_duplicatecustomer_desc", { name: error.data })}
          </Typography>
        </div>
      );
    }
    if (error.type === "error_duplicateorganisation") {
      return (
        <div className={classes.error}>
          <Typography type="subheading" color="inherit">
            {translate("error_duplicateorganisation_title")}
          </Typography>
          <Typography type="body1" color="inherit">
            {translate("error_duplicateorganisation_desc", { name: error.data })}
          </Typography>
        </div>
      );
    }
    if (error.type === "error_duplicateuser") {
      return (
        <div className={classes.error}>
          <Typography type="subheading" color="inherit">
            {translate("error_duplicateuser_title")}
          </Typography>
          <Typography type="body1" color="inherit">
            {translate("error_duplicateuser_desc", { email: error.data })}
          </Typography>
        </div>
      );
    }
  }

  render() {
    const {
      classes,
      translate,
      impersonating,
      profile,
      removeLogo,
      disableFields,
      languages
    } = this.props;

    const activeFeatures = this.props.activeFeatures;

    const { customer, error, errors, isUpdateSettingBtnDisabled, filteredCountries } = this.state;

    let $logoModal = this.state.logoModal ? (
      <CustorgLogo
        container="organisations"
        modal={this.state.logoModal}
        mode="addOrganisationLogo"
        customerId={customer.id}
        customer={customer}
        cancel={this.closeLogoModal}
        translate={translate}
        logoStored={this.closeLogoModal}
      />
    ) : null;

    const archivePeriods = [3, 6, 12, 18, 24];

    return (
      <Paper className={classes.paper}>
        {error && this.getUpdateError(error)}
        {customer.logo ? (
          <Grid item>
            <img alt="" src={customer.logo} className={classes.logo} />
            <Button
              fab
              mini
              color="primary"
              className={`${classes.logoButton} ${classes.logoButtonRemove}`}
              onClick={() => removeLogo(customer.id)}
              aria-label="remove"
              disabled={impersonating || disableFields}
            >
              <Icon className={classes.logoButtonIcon}>remove</Icon>
            </Button>
            <span className={classes.logoName}>{customer.name}</span>
          </Grid>
        ) : (
          <Grid item>
            <div className={classes.LogoMissing}></div>
            <Button
              fab
              mini
              color="primary"
              className={`${classes.logoButton} ${classes.logoButtonAdd}`}
              onClick={() => this.showLogoModal()}
              aria-label="add"
              disabled={impersonating || disableFields}
            >
              <Icon className={classes.logoButtonIcon}>add</Icon>
            </Button>
            <span className={classes.logoName}>{customer.name}</span>
          </Grid>
        )}
        <RoleBasedTextField
          error={errors.name}
          required
          name="name"
          label={translate("organisation_name")}
          margin="normal"
          fullWidth
          value={customer.name}
          onChange={this.onChange}
          helperText={
            errors.name ? errors.name : translate("organisation_name_help")
          }
          disabled={impersonating || disableFields}
        />

        <RoleBasedTextField
          className={classes.textField}
          error={errors.contactfirstname}
          required
          name="contactfirstname"
          label={translate("contactfirstname")}
          margin="normal"
          fullWidth
          value={customer.contactfirstname}
          onChange={this.onChange}
          helperText={
            errors.contactfirstname
              ? errors.contactfirstname
              : translate("customer_contact_first_name_help")
          }
          disabled={impersonating || disableFields}
        />

        <RoleBasedTextField
          className={classes.textField}
          error={errors.contactlastname}
          required
          name="contactlastname"
          label={translate("contactlastname")}
          margin="normal"
          fullWidth
          value={customer.contactlastname}
          onChange={this.onChange}
          helperText={
            errors.contactlastname
              ? errors.contactlastname
              : translate("customer_contact_last_name_help")
          }
          disabled={impersonating || disableFields}
        />

        <RoleBasedTextField
          className={classes.textField}
          error={errors.telephoneno}
          required
          name="telephoneno"
          label={translate("customer_contact")}
          margin="normal"
          fullWidth
          value={customer.telephoneno}
          onChange={this.onChange}
          helperText={
            errors.telephoneno
              ? errors.telephoneno
              : translate("customer_contact_help")
          }
          disabled={impersonating || disableFields}
        />

        <RoleBasedTextField
          className={classes.textField}
          error={errors.contactemail}
          required
          name="contactemail"
          label={translate("customer_email")}
          margin="normal"
          fullWidth
          value={customer.contactemail}
          onChange={this.onChange}
          helperText={
            errors.contactemail
              ? errors.contactemail
              : translate("customer_email_help")
          }
          disabled={impersonating || disableFields}
        />

        <RoleBasedDropDown
          fullWidth
          required
          margin="normal"
          error={errors.language}
          disabled={impersonating || disableFields}
        >
          <InputLabel htmlFor="language">
            {translate("user_language")}
          </InputLabel>
          <Select
            value={customer.language ? customer.language : ""}
            onChange={this.onChange}
            input={
              <Input name="language" id="language" value={customer.language} />
            }
            MenuProps={{
              onBlur:() => {
                this.onCloseCountries();
              },
              onKeyPress:(e) => {
                this.filterCountriesList(e);
              }
            }}
            autoWidth={false}
          >
            {
              languages.map((language, index) => {
                return (
                  <MenuItem
                    key={index}
                    value={language.code}
                  >
                    {language.code}
                  </MenuItem>
                )
              })
            }
          </Select>
          <FormHelperText>
            {errors.language
              ? errors.language
              : translate("user_language_help")}
          </FormHelperText>
        </RoleBasedDropDown>

        <RoleBasedTextField
          error={errors.address}
          name="address"
          label={translate("customer_address")}
          margin="normal"
          fullWidth
          value={customer.address}
          onChange={this.onChange}
          helperText={
            errors.address ? errors.address : translate("customer_address_help")
          }
          disabled={impersonating || disableFields}
        />

        <RoleBasedTextField
          error={errors.city}
          name="city"
          label={translate("customer_city")}
          margin="normal"
          fullWidth
          value={customer.city}
          onChange={this.onChange}
          helperText={
            errors.city ? errors.city : translate("customer_city_help")
          }
          disabled={impersonating || disableFields}
        />
        <RoleBasedDropDown
          fullWidth
          required
          margin="normal"
          error={errors.country}
          disabled={impersonating || disableFields}
        >
          <InputLabel htmlFor="country">
            {translate("customer_country")}
          </InputLabel>
          <Select
            value={customer.country ? customer.country : ""}
            onChange={this.onChange}
            input={
              <Input name="country" id="country" value={customer.country} />
            }
            MenuProps={{
              onBlur:() => {
                this.onCloseCountries();
              },
              onKeyPress:(e) => {
                this.filterCountriesList(e);
              }
            }}
            autoWidth={false}
          >
          {
              filteredCountries.map((country, index) => {
              if (index == 0) {
                return (
                  <MenuItem id='menutop' value={ country.countrycode } key={index}>
                    { country.countryname }
                  </MenuItem>
                );
              }
              return (
                <MenuItem value={ country.countrycode } key={index}>
                  { country.countryname }
                </MenuItem>
              );
            })
          }
          </Select>
          <FormHelperText>
            {errors.country
              ? errors.country
              : translate("customer_country_help")}
          </FormHelperText>
        </RoleBasedDropDown>

        {!this.state.stateexists || this.state.statesOfCountry.length == 0 ? (
          <RoleBasedTextField
            error={errors.state}
            name="state"
            label={translate("customer_state_county")}
            margin="normal"
            fullWidth
            value={customer.state}
            onChange={this.onChange}
            helperText={
              errors.state
                ? errors.state
                : translate("customer_state_county_help2")
            }
            disabled={impersonating || disableFields}
          />
        ) : (
          <RoleBasedDropDown
            fullWidth
            required
            margin="normal"
            error={errors.state}
            disabled={impersonating || disableFields}
          >
            <InputLabel htmlFor="state">
              {translate("customer_state_county")}
            </InputLabel>
            <Select
              value={customer.state}
              onChange={this.onChange}
              input={<Input name="state" id="state" value={customer.state} />}
              autoWidth={false}
            >
              {this.state.statesOfCountry.map((state, index) => {
                return (
                  <MenuItem value={state.statecode} key={index}>{state.statename}</MenuItem>
                );
              })}
            </Select>
            <FormHelperText>
              {errors.state
                ? errors.state
                : translate("customer_state_county_help2")}
            </FormHelperText>
          </RoleBasedDropDown>
        )}

        <RoleBasedTextField
          error={errors.zipcode}
          name="zipcode"
          label={translate("customer_zipcode")}
          margin="normal"
          fullWidth
          value={customer.zipcode}
          onChange={this.onChange}
          helperText={
            errors.zipcode ? errors.zipcode : translate("customer_zipcode_help")
          }
          disabled={impersonating || disableFields}
        />

        <RoleBasedDropDown
          fullWidth
          required
          margin="normal"
          error={errors.chartmeasurement ? true : false}
          disabled={impersonating || disableFields}
        >
          <InputLabel htmlFor="chartmeasurement">
            {translate("customer_chartmeasurement")}
          </InputLabel>
          <Select
            value={customer.chartmeasurement}
            onChange={this.onChange}
            input={
              <Input
                name="chartmeasurement"
                id="chartmeasurement"
                value={customer.chartmeasurement}
              />
            }
            autoWidth={false}
          >
            <MenuItem value={"Feet"}>
              {translate("customer_chart_feet")}
            </MenuItem>
            <MenuItem value={"Meters"}>
              {translate("customer_chart_meter")}
            </MenuItem>
          </Select>
          <FormHelperText>
            {translate("customer_chartmeasurement_help")}
          </FormHelperText>
        </RoleBasedDropDown>

        <RoleBasedDropDown
          fullWidth
          required
          margin="normal"
          error={errors.chartlinestyle ? true : false}
          disabled={impersonating || disableFields}
        >
          <InputLabel htmlFor="chartlinestyle">
            {translate("customer_chartlinestyle")}
          </InputLabel>
          <Select
            value={customer.chartlinestyle}
            onChange={this.onChange}
            input={
              <Input
                name="chartlinestyle"
                id="chartlinestyle"
                value={customer.chartlinestyle}
              />
            }
            autoWidth={false}
          >
            <MenuItem value={"Standard"}>
              {translate("customer_chart_standard")}
            </MenuItem>
            <MenuItem value={"Inverted"}>
              {translate("customer_chart_inverted")}
            </MenuItem>
          </Select>
          <FormHelperText>
            {translate("customer_chartlinestyle_help")}
          </FormHelperText>
        </RoleBasedDropDown>

        <RoleBasedDropDown
          fullWidth
          required
          margin="normal"
          error={errors.wiremapdisplaypreference ? true : false}
          disabled={impersonating || disableFields}
        >
          <InputLabel htmlFor="wiremapdisplaypreference">
            {translate("organisation_wiremap_display_pref")}
          </InputLabel>
          <Select
            value={customer.wiremapdisplaypreference}
            onChange={this.onDisplayPrefChange}
            input={
              <Input
                name="wiremapdisplaypreference"
                id="wiremapdisplaypreference"
                value={customer.wiremapdisplaypreference}
              />
            }
            autoWidth={false}
          >
            <MenuItem value={"Standard"}>
              {translate("chart_line_standard")}
            </MenuItem>
            <MenuItem value={"568A"}>{translate("568-A")}</MenuItem>
            <MenuItem value={"568B"}>{translate("568-B")}</MenuItem>
            <MenuItem value={"TERA"}>{translate("TERA")}</MenuItem>
          </Select>
          <FormHelperText>
            {translate("organisation_wiremap_display_pref_help")}
          </FormHelperText>
        </RoleBasedDropDown>

        {activeFeatures?.some(f => f.featureName === 'automated_archiving') && <RoleBasedDropDown
          fullWidth
          required
          margin="normal"
          error={errors.jobarchiveperiod ? true : false}
          disabled={impersonating || disableFields}
        >
          <InputLabel htmlFor="jobarchiveperiod">
            {translate("customer_jobarchiveperiod")}
          </InputLabel>
          <Select
            value={customer.jobarchiveperiod}
            onChange={this.onChange}
            input={
              <Input
                name="jobarchiveperiod"
                id="jobarchiveperiod"
                value={customer.jobarchiveperiod}
              />
            }
            autoWidth={false}
          >
            <MenuItem key={0} value={0}>{translate("customer_never")}</MenuItem>
            <MenuItem key={1} value={1}>1 {translate("customer_month")}</MenuItem>
            {archivePeriods.map(period =>
                <MenuItem key={period} value={period}>
                  {period} {translate("customer_months")}
                </MenuItem>
            )}
          </Select>
          <FormHelperText>
            {translate("error_select_value")}
          </FormHelperText>
        </RoleBasedDropDown>}

        {activeFeatures?.some(f => f.featureName === 'automated_archiving') && <RoleBasedDropDown
          fullWidth
          required
          margin="normal"
          error={errors.reportarchiveperiod ? true : false}
          disabled={impersonating || disableFields}
        >
          <InputLabel htmlFor="reportarchiveperiod">
            {translate("customer_reportarchiveperiod")}
          </InputLabel>
          <Select
            value={customer.reportarchiveperiod}
            onChange={this.onChange}
            input={
              <Input
                name="reportarchiveperiod"
                id="reportarchiveperiod"
                value={customer.reportarchiveperiod}
              />
            }
            autoWidth={false}
          >
            <MenuItem key={0} value={0}>{translate("customer_never")}</MenuItem>
            <MenuItem key={1} value={1}>1 {translate("customer_month")}</MenuItem>
            {archivePeriods.map(period =>
                <MenuItem key={period} value={period}>
                  {period} {translate("customer_months")}
                </MenuItem>
            )}
          </Select>
          <FormHelperText>
            {translate("error_select_value")}
          </FormHelperText>
        </RoleBasedDropDown>}

        <RoleBasedButton
          raised
          fullWidth
          color="primary"
          className={classes.button}
          type="submit"
          onClick={this.handleSubmit}
          disabled={disableFields || impersonating}
        >
          {translate("profile_update_details")}
        </RoleBasedButton>
        {$logoModal}
      </Paper>
    );
  }
  componentDidMount() {
    const { allCountries } = this.state;
    if (allCountries.length <= 0) {
      this.setState({ allCountries: this.props.countryStates.countries, filteredCountries: this.props.countryStates.countries })
    }
    if (this.props.customer) {
      let customer = {
        ...this.props.customer
      }; //remove this once the api is updated
      this.setState({
        customer
      });
      if (customer.country) {
        let statesOfCountry = null;
        let countries = this.props.countryStates.countries.filter(
          c => c.countrycode == customer.country
        );
        let country = countries && countries.length ? countries[0] : "";
        if (country.stateexists)
          statesOfCountry = this.props.countryStates.states.filter(
            s => s.countrycode == country.countrycode
          );
        this.setState({
          stateexists: country.stateexists,
          statesOfCountry: statesOfCountry
        });
      }
    }
  }
  componentWillReceiveProps(nextProps) {
    let customer = { ...nextProps.customer };
    if (customer.id !== this.state.customer.id) {
      this.setState({
        customer
      });
    } else {
      // add logo and logopath to customer state
      this.setState({
        customer: {
          ...this.state.customer,
          logo: customer.logo,
          logopath: customer.logopath
        }
      });
    }
  }
}

export default withStyles(styles)(Organisation);
